import React, { useState } from "react";
import google from "../../assets/images/google.svg";
import { Form, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { API_URL } from "../../services/APIRoute";
import { apiCall } from "../../services/AxiosService";
import { apiResponse } from "../../services/APIResponse";
import {
  organizations,
  userInfo,
  userRoleRight,
  userToken,
} from "../../services/ReduxTookit/UserInfoSlice";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { GoogleCallBack } from "../../services/ReduxTookit/Slice/GoogleRedux";
import MainpageLoader from "../common-component/Loaders/MainpageLoader";

const SignWithGoogle = () => {
  const [googleLoading, setGoogleLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      setGoogleLoading(true);
      const accessToken = tokenResponse.access_token;
      try {
        const userInfoResponse = await axios.get(
          "https://www.googleapis.com/oauth2/v2/userinfo",
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              // requesturl: window.location.origin,
              // Access-Control-Allow-Origin: "*"
            },
            // mode: "cors",
          }
        );
        let body = {
          firstname: userInfoResponse?.data?.given_name || "",
          lastname: userInfoResponse?.data?.family_name || "",
          email: userInfoResponse?.data?.email || "",
          googleprofileid: userInfoResponse?.data?.id || "",
          profilepic: userInfoResponse?.data?.picture || "",
        };
        dispatch(GoogleCallBack(body)).then((response) => {
          if (response?.payload?.isValidate) {
            setGoogleLoading(false);
            if (response?.payload?.data?.data?.dataList1[0]?.istwostepenable) {
              navigate("/authentication", {
                state: response?.payload?.data?.data?.dataList1[0],
              });
            } else {
              // dispatch(
              //   userToken(
              //     response?.payload?.data?.data?.dataList1[0]?.accesstoken
              //   )
              // );
              // dispatch(organizations(response?.payload?.data?.data?.dataList3));
              // dispatch(userInfo(response?.payload?.data?.data?.dataList1[0]));
              // dispatch(userRoleRight(response?.payload?.data?.data?.dataList2));
              dispatch(
                userToken(
                  response?.payload?.data?.data?.dataList1[0]?.accesstoken
                )
              );
              if (response?.payload?.data?.data?.dataList1) {
                dispatch(userInfo(response?.payload?.data?.data?.dataList1[0]));
              }
              if (response?.payload?.data?.data?.dataList2) {
                dispatch(
                  userRoleRight(response?.payload?.data?.data?.dataList2)
                );
              }
              if (response?.payload?.data?.data?.dataList3) {
                dispatch(
                  organizations(response?.payload?.data?.data?.dataList3)
                );
              }

              if (
                response?.payload?.data?.data?.dataList1[0]?.associationtype ===
                "Reviewers"
              ) {
                navigate("/machine-review");
              } else {
                navigate("/dashboard");
              }
            }
          }
          if (!response?.payload?.isValidate) {
            navigate("/");
            setGoogleLoading(false);
          }

          // if (res?.payload?.isValidate) {
          //   setGoogleLoading(false);
          //   dispatch(
          //     userToken(res?.payload?.data?.data?.dataList1[0]?.accesstoken)
          //   );
          //   dispatch(userInfo(res?.payload?.data?.data?.dataList1[0]));
          //   dispatch(userRoleRight(res?.payload?.data?.data?.dataList2));
          //   if (
          //     res?.payload?.data?.data?.dataList1[0]?.associationtype ===
          //     "Reviewers"
          //   ) {
          //     navigate("/machine-review");
          //   } else {
          //     navigate("/dashboard");
          //   }
          // } else {
          //   navigate("/");
          //   setGoogleLoading(false);
          // }
        });

        // ------------- Before redux
        // let resData = await apiCall(
        //   {
        //     method: "POST",
        //     url: API_URL.BASEURL + API_URL?.USER_GOOGLE_LOGIN,
        //     body: body,
        //   },
        //   true
        // );
        // let response = apiResponse(true, resData, setGoogleLoading);
        // if (response?.isValidate) {
        //   dispatch(userToken(response?.data?.data?.dataList1[0]?.accesstoken));
        //   dispatch(userInfo(response?.data?.data?.dataList1[0]));
        //   dispatch(userRoleRight(response?.data?.data?.dataList2));
        //   if (
        //     response?.data?.data?.dataList1[0]?.associationtype === "Reviewers"
        //   ) {
        //     navigate("/machine-review");
        //   } else {
        //     navigate("/dashboard");
        //   }
        // }
        // if (!response?.isValidate) {
        //   navigate("/");
        // }
      } catch (error) {
        toast.error(error);
      } finally {
        setGoogleLoading(false);
      }
    },
    onError: () => toast.error("Login Failed"),
    flow: "implicit",
  });
  return (
    <>
      {googleLoading && <MainpageLoader />}
      <button
        disabled={googleLoading}
        className="white-sign-in-btn w-100"
        type="reset"
        onClick={() => googleLogin()}
      >
        {googleLoading ? (
          <>
            <span>Loading</span>{" "}
            <Spinner
              className="ms-1"
              animation="border"
              role="status"
              size="sm"
            >
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </>
        ) : (
          <>
            <span>
              <img src={google} alt="google" />
            </span>
            <span>Google</span>
          </>
        )}
      </button>
    </>
  );
};

export default SignWithGoogle;
